import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { WrenchIcon, XIcon } from 'lucide-react';
import { PURCHASE_ANCHOR, popupSales } from '../data/content';
export function SalesPopup() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const reduceMotion = useReducedMotion();
  useEffect(() => {
    if (dismissed) return;
    let timeout: ReturnType<typeof setTimeout>;
    const cycle = (i: number) => {
      timeout = setTimeout(() => {
        setIndex(i % popupSales.length);
        setVisible(true);
        timeout = setTimeout(() => {
          setVisible(false);
          cycle(i + 1);
        }, 5200);
      }, 3200);
    };
    cycle(0);
    return () => clearTimeout(timeout);
  }, [dismissed]);
  const sale = popupSales[index];
  const y = reduceMotion ? 0 : 14;
  return <AnimatePresence data-id="element-132" data-mp="18r43t5q8zj76">
      {visible && !dismissed ? <motion.aside initial={{
      opacity: 0,
      y,
      scale: reduceMotion ? 1 : 0.96
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y,
      scale: reduceMotion ? 1 : 0.96
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed bottom-2 left-2 z-50 w-[14.5rem] overflow-hidden rounded-lg border-2 border-gold bg-white shadow-popup ring-2 ring-electric/60 sm:w-[17rem]" aria-live="polite" data-id="element-133" data-mp="1zrutxh26rqjd">
          <div className="flex items-center gap-1.5 bg-gold px-2 py-1" data-id="element-134" data-mp="2nh71kchv7qjk">
            <WrenchIcon className="h-3.5 w-3.5 text-navy-deep" aria-hidden="true" data-id="element-135" data-mp="2nfckj99psikr" />
            <p className="font-heading text-[0.56rem] font-black uppercase tracking-[0.14em] text-navy-deep" data-id="element-136" data-mp="2sgtf6n1lv8sw">
              New purchase verified
            </p>
            <button type="button" onClick={() => setDismissed(true)} aria-label="Dismiss notification" className="ml-auto text-navy-deep/70 transition-colors duration-150 ease-out hover:text-navy-deep" data-id="element-137" data-mp="y2sh44dvqptv">
              <XIcon className="h-3 w-3" aria-hidden="true" data-id="element-138" data-mp="q1kvmjs1ktj7" />
            </button>
          </div>
          <a href={PURCHASE_ANCHOR} className="block border-l-4 border-electric px-2 py-1.5" data-id="element-139" data-mp="q3xjfdkhdy46">
            <p className="text-[0.72rem] font-bold leading-tight text-navy" data-id="element-140" data-mp="14whctmhtwr8f">
              {sale.name} just bought KITCHEN EQUIPMENT DIAGNOSTIC PRO™
            </p>
            <p className="mt-0.5 text-[0.62rem] font-semibold text-steel/80" data-id="element-141" data-mp="1dxxm1qwwqnb2">
              {sale.city}, {sale.country} • a few minutes ago
            </p>
          </a>
        </motion.aside> : null}
    </AnimatePresence>;
}